import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { QuantityUnitToStringPipe } from 'projects/shared/lib/pipes/quantity-unit/quantity-unit-to-string.pipe';
import { EShoppingCartItemValidationError, QuantityUnitDto, ShoppingCartItemValidationErrorDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

@Component({
    selector: 'app-cart-validation-result-cart-item',
    imports: [
        CommonModule,
        QuantityUnitToStringPipe,
    ],
    templateUrl: './cart-validation-result-cart-item.component.html',
    styleUrls: ['./cart-validation-result-cart-item.component.scss']
})
export class CartValidationResultCartItemComponent implements OnChanges {
  @Input() public cartItemValidationError?: ShoppingCartItemValidationErrorDto | undefined;
  @Input() public availableQuantity?: number | undefined;
  @Input() public quantityUnit?: QuantityUnitDto | undefined;

  public readonly eCartItemValidationError: typeof EShoppingCartItemValidationError;

  public shouldDisplayAvailableQuantity?: boolean | undefined;
  public quantity?: number | undefined;

  public constructor() {
    this.eCartItemValidationError = EShoppingCartItemValidationError;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      switch (propName) {
        case 'cartItemValidationError': {
          this.stockInformationVisibilityUpdate();
          break;
        }
        case 'availableQuantity': {
          this.stockInformationVisibilityUpdate();
          break;
        }
        case 'quantityUnit': {
          this.stockInformationVisibilityUpdate();
          break;
        }
        default: {
          throw new Error('Input property handler not implemented.');
        }
      }
    }
  }

  protected stockInformationVisibilityUpdate() {
    let shouldDisplayStockInformation = this.cartItemValidationError?.shoppingCartItemValidationError === EShoppingCartItemValidationError.ProductIsOutOfStock;

    if (this.availableQuantity != undefined && shouldDisplayStockInformation == true) {
      this.shouldDisplayAvailableQuantity = this.availableQuantity > 0;
      if (this.shouldDisplayAvailableQuantity == true) {
        this.quantityDisplayUpdate(this.availableQuantity, this.quantityUnit);
      }
    } else {
      this.shouldDisplayAvailableQuantity = undefined;
    }
  }

  private quantityDisplayUpdate(availableQuantity: number, quantityUnit?: QuantityUnitDto | undefined) {
    let quantityUnitHasSmallerUnit = quantityUnit?.consistsOfQuantity != undefined;
    let availableQuantityRounded = Math.floor(availableQuantity * 100) / 100;
    if (!quantityUnitHasSmallerUnit) {
      availableQuantityRounded = Math.floor(availableQuantityRounded);
    }
    this.quantity = availableQuantityRounded;
  }

}
